import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {

  public title: string;
  public message: string;
  public confirmLabel: string;
  public cancelLabel: string;
  /** Red confirm button: the one place a destructive action is red (DESIGN.md, ruling 2026-09-28). */
  public destructive: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel
  ) {
    this.title = data.title;
    this.message = data.message;
    this.confirmLabel = data.confirmLabel || 'Yes';
    this.cancelLabel = data.cancelLabel || 'No';
    this.destructive = !!data.destructive;
  }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }

}

export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
    public confirmLabel: string = 'Yes',
    public cancelLabel: string = 'No',
    public destructive = false,
  ) { }
}
